export default "__VITE_ASSET__D2xuG36U__"